import {Form, SelectPicker} from "rsuite";
import React, {useEffect, useState} from "react";

const OPERATION_TYPES = ['greaterThan', 'lessThan'];

const YearsOfExpSearchForm = () => {

    const [operationTypes, setOperationTypes] = useState([]);

    useEffect(() => {
        setOperationTypes(OPERATION_TYPES.map(ele => ({label: ele, value: ele})));
    }, []);

    return (
        <>
            <Form.Group>
                <Form.ControlLabel>Years of Experience</Form.ControlLabel>
                <Form.Control name="yoe"
                              style={{width: 200}}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Operation</Form.ControlLabel>
                <Form.Control
                    name="operation"
                    accepter={SelectPicker}
                    data={operationTypes}
                />
            </Form.Group>
        </>
    );
};

export default YearsOfExpSearchForm;